import React, { Fragment, useEffect, useState } from "react";
import Button from "components/form/Button";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  refreshTokenExpire,
  updateTokenExpiredStatus,
  updateTokenStatus,
} from "store/slices/authSlice";
import { RootState } from "store/store";
import { useTid } from "utils/testid";

const SessionExpiryModel = () => {
  const tid = useTid();
  const dispatch = useAppDispatch();
  const [currentSecond, setCurrentSecond] = useState(60);
  const { isExpiry, isTokenRefreshing } = useAppSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    if (isExpiry) {
      setCurrentSecond(60);
      intervalId = setInterval(() => {
        setCurrentSecond((state) => {
          if (state > 0) {
            return state - 1;
          } else {
            dispatch(updateTokenStatus(false));
            dispatch(updateTokenExpiredStatus(true));
            // handleLogOut();
            return 0;
          }
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch, isExpiry]);

  return (
    <Fragment>
      <div
        className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]"
        data-testid={tid("session-expiring-message")}
        aria-label={`Session expires in ${currentSecond} seconds`}
        aria-live="polite"
      >
        Your session is about to expire due to inactivity. You will be logged
        out in {currentSecond} seconds.
      </div>
      <div className="w-full flex justify-end items-center lg:pt-[30px] pt-5">
        <Button
          text="Stay logged in"
          isLoading={isTokenRefreshing}
          data-testid={tid("stay-logged-in-button")}
          aria-label="Stay logged in"
          onClick={() => {
            dispatch(refreshTokenExpire({}));
          }}
          className="lg:w-fit w-full"
        />
      </div>
    </Fragment>
  );
};

export default SessionExpiryModel;
